import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { ColumnHeaderSortable } from '../../../DataTable/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'col-cryptocurrencies',
  title: 'Cryptocurrencies'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }
}

class DetailColumn extends React.Component {

  render() {
    const SELECT_TOP_ASSETS = 3;
    const { assets } = this.props.row;
    const topAssets = assets?.slice(0, SELECT_TOP_ASSETS);
    const remainingAssets = assets?.slice(SELECT_TOP_ASSETS);
    const showTooltip = remainingAssets && remainingAssets.length > 0;

    const Link = ({ id, children, title }) => (
      <OverlayTrigger className={'text-left'} overlay={<Tooltip bsPrefix={'text-left pre-line tooltip'} id={id}>{title}</Tooltip>} trigger={'focus'}>
        <a href="#">{children}</a>
      </OverlayTrigger>
    );
    const tooltipTitle = remainingAssets.map(asset => asset.formattedTitle).join('\n');
    return (
      <td className='d-flex'>
        {topAssets?.map(asset => (
          <a key={`asset_${asset.id}`} href={asset.permalink} className="d-flex mr-3">
            <img alt={asset.formattedTitle} title={asset.formattedTitle} src={asset.image} className="cs-asset-image" />
          </a>
        ))}
        {showTooltip && (
          <Link title={tooltipTitle} id="cs-crypto-tooltip">
          +{remainingAssets.length}
        </Link>
        )}
      </td>
    );
  }
}


class Cryptocurrencies extends Column {
  get id() {
    return columnOptions.id;
  }

  /**
   * This column must always be displayed
   */
  get isConfigurable() {
    return false;
  }

  get title() {
    return columnOptions.title;
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default Cryptocurrencies;

